import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

export function SkeletonTile() {
  return (
    <Card
      sx={{
        minHeight: 240,
        flex: 1,
        width: "100%",
        height: "100%",
        padding: 3,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "transparent",
        borderRadius: 2,
        border: "2px solid #444444",
        transition: "border-color 150ms ease",
      }}
    >
      <CardContent
        sx={{
          borderRadius: 2,
          color: "text.primary",
          p: "0 !important",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
        }}
      >
        <Stack
          flexDirection={"column"}
          gap={2}
          sx={{ flex: 1, minHeight: 0 }}
          alignItems={"flex-start"}
          alignContent={"stretch"}
        >
          <Box
            sx={{
              display: "flex",
              alignSelf: "stretch",
              height: "206px",
              width: "100%",
              flexDirection: "column",
              gap: "10px",
              borderRadius: 2,
            }}
          >
            <Skeleton variant="rectangular" width={"100%"} height={206} />
          </Box>
          <Stack
            sx={{ gap: 2, flex: 1, minHeight: 0 }}
            justifyContent={"space-between"}
            direction={"column"}
            alignSelf={"stretch"}
          >
            <Skeleton variant={"text"} width={"80%"} height={30} />
            <Stack
              sx={{
                justifyContent: "space-between",
                alignItems: "center",
                alignSelf: "stretch",
              }}
              direction={"row"}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Skeleton variant="circular" width={24} height={24} />
                <Skeleton variant="text" width={120} />
              </div>
              <Skeleton variant="text" width={120} />
            </Stack>
            <Skeleton variant="text" width={100} />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
